import { createSlice } from '@reduxjs/toolkit';

const readingSlice = createSlice({
  name: 'reading',
  initialState: {
    readings: [],
    loading: false,
    error: null
  },
  reducers: {}
});

export default readingSlice.reducer;